import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { setLocalization } from '../consts/tableOptions';

const useTableLocalization = () => {
  const language = useSelector(({ auth }) => auth.lang);

  const localization = useMemo(() => {
    return { ...setLocalization() };
    // eslint-disable-next-line
  }, [language]);

  return { localization, language };
};

export default useTableLocalization;
